



















































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import * as fabric from "@/models/products/fabric";
import { Mobile } from "@/mixins/mobile";
import { FabricComponent } from "@/models/configurator/fabric_components";

@Component
export default class FabricFilter extends Mixins(Mobile) {
  /**
   * For filtering purposes, all filters are case sensitive to their match to what is returned by API
   * Only change to match how these values are being returned by API
   */
  @Prop() isStockOnly!: boolean;
  @Prop() filters!: fabric.FabricFilter;
  @Prop({ default: false }) solidsOnly!: boolean;
  @Prop({ default: false }) noStripes!: boolean;
  @Prop({ default: false }) gradeAOnly!: boolean;
  @Prop() mainFabricWeight!: string;
  @Prop({ default: null }) component!: FabricComponent | null;
  protected grades: string[] = ["a", "ap", "b", "c", "d", "e", "f"];
  // Categories below are set by client
  protected colors: string[] = [
    "Beige",
    "Black",
    "Blue",
    "Brown",
    "Gold",
    "Gray",
    "Green",
    "Ivory",
    "Orange",
    "Pink",
    "Purple",
    "Red",
    "Turquoise",
    "White",
    "Yellow"
  ];
  protected designs: string[] = [
    "Solids",
    "Stripes",
    "Textures",
    "Geometrics",
    "Tweeds"
  ];
  protected mfrs: string[] = ["sunbrella", "sattler", "recasens"];
  protected weights: string[] = ["8", "9"];

  get isNotSpecialFabricComponent(): boolean {
    if (
      this.component !== FabricComponent.Main &&
      this.component !== FabricComponent.Binding
    ) {
      return true;
    } else {
      return false;
    }
  }

  public makeSentenceCase(sentence: string) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  protected highlightColor(color: string): boolean {
    let highlight = false;
    if (this.filters.color.length > 0 && this.filters.color.includes(color)) {
      highlight = true;
    }
    return highlight;
  }

  /** The following set####()methods communicate user selected filters to the fabric swatch display (FabricSelector.vue) */
  protected setGrade(value: string): void {
    this.$emit("setGrade", value);
  }

  /** Color filters are additive, whilst other filters are just one at a time */
  protected setColor(value: string): void {
    const colorArray =
      this.filters.color.length > 0 ? [...this.filters.color] : [];
    if (!value) {
      // clear color filters
      this.$emit("setColor", []);
    } else if (this.filters.color.includes(value)) {
      // if the color selected is already in the color filter array when it is clicked, remove it
      const newColors = colorArray.filter(color => color !== value);
      this.$emit("setColor", newColors);
    } else {
      colorArray.push(value); // if the colors selected is not present in the color filter array, add it to the filters
      this.$emit("setColor", colorArray);
    }
  }

  protected setDesign(value: string): void {
    this.$emit("setDesign", value);
  }

  protected setMfr(value: string): void {
    this.$emit("setMfr", value);
  }

  protected setWeight(value: string): void {
    this.$emit("setWeight", value);
  }
}
